export function myPhotoAdd(imageBase64, secret, callback) {
	return {
    type: 'MY_PHOTO_ADD',
		payload: {
			imageBase64: imageBase64,
      secret: secret,
		},
    callback: callback,
	}
}

export function myPhotoMainAdd(imageBase64, restriction, callback) {
	return {
    type: 'MY_PHOTO_MAIN_ADD',
		payload: {
			imageBase64: imageBase64,
      restriction: restriction,
		},
    callback: callback,
	}
}

export function myPhotoMainRequest(id, restriction) {
	return {
    type: 'MY_PHOTO_MAIN_REQUEST',
		payload: {
			id: id,
			restriction: restriction,
		},
	}
}

export function myPhotoMainRequestStop() {
	return {
    type: 'MY_PHOTO_MAIN_REQUEST_STOP',
	}
}

export function myPhotoMainRestriction(restriction) {
	return {
    type: 'MY_PHOTO_RESTRICTION_EDIT',
		payload: {
			restriction: restriction,
		}
	}
}


export function myPhotoMainDel(callback) {
	return {
    type: 'MY_PHOTO_MAIN_DEL',
		callback: callback,
	}
}

export function myPhotoSecret(id, secret) {
	return {
    type: 'MY_PHOTO_SECRET',
		payload: {
			id: id,
			secret: secret,
		},
	}
}
export function myPhotoRotate(id, lr) {
	return {
    type: 'MY_PHOTO_ROTATE',
		payload: {
			id: id,
			lr: lr,
		},
	}
}

export function myPhotoDel(id) {
	return {
    type: 'MY_PHOTO_DEL',
		payload: {
			id: id,
		},
	}
}

export function myPhotoRekognitionCheck(imageBase64, callback) {
	return {
    type: 'MY_PHOTO_REKOGNITION_CHECK',
		payload: {
			imageBase64: imageBase64,
		},
    callback: callback,
	}
}
